const MembershipHero = () => {
  return (
    <section className="h-screen px-4 pb-4" data-cy="membership-hero">
      <div className="flex h-full items-center justify-center rounded-b-2xl bg-green-900">
        <h2 className="text-6xl text-white">
          More personal, more intuitive, more you
        </h2>
      </div>
    </section>
  );
};

export default MembershipHero;
